import React from "react";

import { useLocation, useNavigate } from "react-router-dom";
import Header from "../../layouts/Header";
import { ArrowLeft } from "lucide-react";
import DonationsView from "../../components/Donations";
import Toaster from "../../components/ui/toaster";

export default function SettingsDonationsView() {
  const location = useLocation();
  const navigate = useNavigate();
  const data = location.state?.donation || "";

  return (
    <>
      <Header />
      <Toaster />
      <div className="min-h-screen w-full bg-gray-100 flex flex-col">
        {/* Top Gradient Bar */}
        <div className="h-14 bg-gradient-to-r from-blue-600 to-purple-600 flex items-center pl-20 text-white">
          <ArrowLeft
            className="mr-5 bg-transparent rounded-full p-1 border-gray-200/60 border hover:border-gray-400 hover:bg-white/20 cursor-pointer"
            onClick={() => {
              navigate("/settings/donations");
            }}
          />
          <p className="text-sm font-medium underline mr-2">Settings</p>
          <p className="text-sm font-medium">
            {" "}
            / Donations / {data?.organisation_info?.org_name}
          </p>
        </div>
        {/* Main Content */}
        <DonationsView organisation={data} />
      </div>
    </>
  );
}
